import { render, staticRenderFns } from "./PatientsModal.vue?vue&type=template&id=fffde79a&"
import script from "./PatientsModal.vue?vue&type=script&lang=js&"
export * from "./PatientsModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientsModal.vue?vue&type=style&index=0&id=fffde79a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports